import { Icon } from '../icon/icon';
import cls from './wrapped-icon.module.scss';

interface WrappedIconProps {
  pathToIcon: string;
  color: 'red' | 'green';
  size?: number;
  className?: string;
}

export const WrappedIcon: React.FC<WrappedIconProps> = (
  props: WrappedIconProps
) => {
  const { pathToIcon, color, size = 24, className } = props;
  return (
    <div className={`${cls[color]} ${cls.wrapper} ${className ?? ''}`}>
      <Icon pathToIcon={pathToIcon} size={size} />
    </div>
  );
};
